import { GraphQLResult } from "@aws-amplify/api-graphql";
import { API, graphqlOperation } from "aws-amplify";
import { CreateOrderInput, CreateOrderMutation, Order } from "../../API";
import { createOrder } from "../../graphql/mutations";

export const OrderRepository = () => {
  const fetchByCustomerId = () => {};

  const create = (orderInput: CreateOrderInput) => {
    return new Promise<Order>(async (res) => {
      const result = (await API.graphql(
        graphqlOperation(createOrder, { input: orderInput })
      )) as GraphQLResult<CreateOrderMutation>;
      console.debug(result);
      res(result.data?.createOrder as Order)
    });
  };

  return {
    fetchByCustomerId,
    create,
  };
};
